/* eslint-disable no-empty */
import { UserTask } from '@hefe/models';
import { createApi } from '@reduxjs/toolkit/query/react';
import API from '../../../api/api';

export const userApi = createApi({
  reducerPath: 'apiUser',
  baseQuery: API.baseQuery,
  endpoints: (builder) => ({
    fetchUserTasks: builder.query<UserTask[], void>({
      query: (request) => ({
        url: '/user/tasks',
        method: 'GET',
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const { useFetchUserTasksQuery, reducerPath, reducer, middleware } =
  userApi;
